import { compose, isNil } from 'ramda';
import Utils from 'src/utils';
import store from 'src/store';
import { selectAllEmployees } from 'src/store/selectors/employees';
export { excludeDepartmentOptions } from './departmentOptionsUtil';
export function getDepartmentsTree(departments) {
    if (!departments.length)
        return [];
    const departmentsCopy = departments.map((department) => ({ ...department }));
    const departmentsMap = compose(Utils.objects.normalizeList('DepartmentId'))(departmentsCopy);
    const departmentsRootList = [];
    departmentsCopy.forEach((department) => {
        const departmentId = department.DepartmentId;
        const departmentParentId = department.DepartmentParentId;
        if (isNil(departmentParentId) || !departmentsMap[departmentParentId]) {
            departmentsRootList.push(departmentsMap[departmentId]);
        }
        else {
            const parentDepartment = departmentsMap[departmentParentId];
            if (!parentDepartment.children)
                parentDepartment.children = [];
            parentDepartment.children.push(departmentsMap[departmentId]);
        }
    });
    return Utils.arrays.sortTree(departmentsRootList, 'DepartmentName');
}
export function departmentsTreeToOptions(departmentsTree) {
    const options = [];
    departmentsTree?.forEach((department) => {
        const option = {
            value: department.DepartmentId.toString(),
            label: department.DepartmentName,
            externalCode: department.ExternalCode || ''
        };
        if (department.children) {
            option.children = departmentsTreeToOptions(department.children);
        }
        options.push(option);
    });
    return [...options];
}
export function departmentToFlatOption(department) {
    return ({
        value: department.DepartmentId.toString(),
        label: department.DepartmentName || '',
        externalCode: department.ExternalCode || ''
    });
}
export function getMembersIdsOfDepartments(departmentIds, allUsers) {
    const departmentIdsKeyMap = Utils.arrays.arrayToKeyMap(departmentIds || [], true);
    const users = allUsers || selectAllEmployees(store.getState()) || [];
    return users.reduce((ids, user) => {
        if (user.DepartmentId in departmentIdsKeyMap) {
            return ids.concat(user.UserId);
        }
        else {
            return ids;
        }
    }, []);
}
